
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cenik",
      function () {
        return require("private-next-pages/cenik/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cenik"])
      });
    }
  